"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const InputWidget_1 = tslib_1.__importDefault(require("../widget/InputWidget"));
const KeyboardEventCodes_1 = require("../../util/KeyboardEventCodes");
/**
 * @deprecated use {@link WCAGCPRField}
 */
class CPRInputField extends InputWidget_1.default {
    constructor(element, allowECPR = false) {
        super(element);
        this.allowECPR = allowECPR;
        this.init();
    }
    isValid() {
        const value = this.getInput().value;
        if (!value) {
            return false;
        }
        return this.getRegExp().test(value.toUpperCase());
    }
    getValue() {
        const v = super.getValue();
        if (v) {
            return v.toUpperCase();
        }
        return v;
    }
    parseValueFromInput(v) {
        return v && this.getRegExp().test(v.toUpperCase()) ? v : undefined;
    }
    decorateElement(element) {
        element.type = "text";
        element.autocomplete = "off";
        element.classList.add("field", "cprInputField");
        element.addEventListener("focus", () => element.select());
        element.setAttribute("style", "text-transform:uppercase");
    }
    setValueOnInput(value, input) {
        // Update field value
        if (!value) {
            input.value = "";
        }
        else {
            input.value = value;
        }
    }
    init() {
        const field = this.getInput();
        field.maxLength = CPRInputField.CPR_MAX_LENGTH;
        field.addEventListener("keypress", event => {
            if (event.ctrlKey || event.keyCode === 8 || event.keyCode === 13) {
                // FireFox+Edge generate (blockable) keypress events for tab, backspace, arrow keys, and control inputs,
                // so we need to allow these
                return;
            }
            const character = (0, KeyboardEventCodes_1.getChar)(event).toUpperCase();
            const pos = field.selectionStart;
            if (!this.isValidNextChar(character, pos)) {
                event.preventDefault();
            }
            this.insertDashAndTrimCprNumber(field, field.value, character);
        });
        field.addEventListener("paste", event => {
            // We have to prevent the paste behaviour as we are are setting the field ourselves
            event.preventDefault();
            const afterPasting = this.buildPasteString(event);
            const hasDash = afterPasting.includes("-");
            const isValidCpr = this.getRegExp().test(afterPasting.toUpperCase());
            let isValid = true;
            if (afterPasting.length >= CPRInputField.CPR_MAX_LENGTH && hasDash && !isValidCpr) {
                isValid = false;
            }
            else if (afterPasting.length >= CPRInputField.CPR_MAX_LENGTH - 1 && !hasDash && !isValidCpr) {
                isValid = false;
            }
            else {
                const hasInvalidCharacter = afterPasting
                    .split("")
                    .some((letter, index) => !this.isValidNextChar(letter, index));
                if (hasInvalidCharacter) {
                    isValid = false;
                }
            }
            if (isValid) {
                this.insertDashAndTrimCprNumber(field, afterPasting);
            }
        });
    }
    buildPasteString(event) {
        const target = event.target;
        const currentValue = target.value ?? "";
        const start = currentValue.substring(0, target.selectionStart);
        // window.clipboardData is for IE11, also text/plain doesn't work in IE11
        const pasted = (event.clipboardData || window.clipboardData).getData("text").trim();
        const end = currentValue.substring(target.selectionStart, currentValue.length);
        return `${start}${pasted}${end}`;
    }
    getRegExp() {
        return this.allowECPR
            ? CPRInputField.CPR_REGEXP_ECPR
            : CPRInputField.CPR_REGEXP;
    }
    insertDashAndTrimCprNumber(field, newValue, nextChar) {
        let nextValue = undefined;
        if (nextChar !== "-" && newValue?.length >= 6 && newValue.indexOf("-") === -1) {
            nextValue = `${newValue.substring(0, 6)}-${newValue.substring(6)}`.trim();
        }
        else if (newValue) {
            nextValue = `${newValue}`.trim();
        }
        if (nextValue) {
            field.value = nextValue;
            this.setValue(nextValue);
        }
    }
    isValidNextChar(ch, cursorPos) {
        if (cursorPos === 6 && ch === "-") {
            return true;
        }
        if (ch >= "0" && ch <= "9") {
            return true;
        }
        return this.allowECPR && cursorPos >= 8 && cursorPos <= 9 && (ch >= "A" && ch <= "Z" || "ÆØÅ".includes(ch));
    }
}
CPRInputField.CPR_REGEXP = /^(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[012])\d\d-?\d\d\d\d$/;
CPRInputField.CPR_REGEXP_ECPR = /^(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[012])\d\d-?\d[A-Z0-9ÆØÅ][A-Z0-9ÆØÅ]\d$/;
CPRInputField.CPR_MAX_LENGTH = 11;
exports.default = CPRInputField;
//# sourceMappingURL=CPRInputField.js.map